import { render } from "./LangChangeBtn.vue?vue&type=template&id=6e0e17a8&scoped=true&ts=true"
import script from "./LangChangeBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./LangChangeBtn.vue?vue&type=script&setup=true&lang=ts"

import "./LangChangeBtn.vue?vue&type=style&index=0&id=6e0e17a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0e17a8"],['__file',"src/components/header/LangChangeBtn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e0e17a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e0e17a8', __exports__)) {
    api.reload('6e0e17a8', __exports__)
  }
  
  module.hot.accept("./LangChangeBtn.vue?vue&type=template&id=6e0e17a8&scoped=true&ts=true", () => {
    api.rerender('6e0e17a8', render)
  })

}


export default __exports__